<finxone-web-frontend-switch-navigator-quick-link
  [widgetData]="widgetData"
  [pageUrlsData]="pageUrlsData"
  [contentStyle]="contentStyle"
  [activeSwitchStyle]="activeSwitchStyle"
  [marginBorderStyle]="marginBorderStyle"
></finxone-web-frontend-switch-navigator-quick-link>
